function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteAdhesiveSpeciallyForLightBaseTile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 103.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 8.66,
    width: 91.5,
    height: 90.41,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,84.77l-5.83,2.34Q27.05,91.55,16,96a1.36,1.36,0,0,1-1.1,0c-4.12-1.66-8.24-3.32-12.37-5-.25-.1-.31-.23-.31-.5V81.48c0-.26,0-.39.31-.49q7.8-3.1,15.59-6.24a1,1,0,0,1,.82,0l24.66,9.92.35.15Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.25,84.75l10.27-4.13q7.28-2.93,14.56-5.85a1.24,1.24,0,0,1,1,0Q89.87,77.91,97.65,81a.43.43,0,0,1,.32.49v9.09c0,.27-.06.4-.31.5q-6.24,2.48-12.47,5a1.12,1.12,0,0,1-.88,0L56.74,85l-.49-.23Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,72.12l-6.57,2.65q-9.12,3.66-18.22,7.32a1.44,1.44,0,0,1-1.15,0l-24-9.67-.75-.31,5.45-2.2,19.14-7.69a1.75,1.75,0,0,1,1.42-.07q12.17,4.92,24.35,9.79l.37.18Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.26,59.45,62,57.14l19.13-7.69a1.12,1.12,0,0,1,.93,0q7.81,3.15,15.65,6.27a.35.35,0,0,1,.26.4v6.69a.39.39,0,0,1-.3.43q-7.8,3.1-15.59,6.25a1,1,0,0,1-.82.06q-12.3-5-24.62-9.89l-.39-.19Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,59.47l-5.63,2.27q-9.57,3.84-19.14,7.69a1.48,1.48,0,0,1-1.2,0q-7.71-3.12-15.43-6.19a.42.42,0,0,1-.33-.47V56.14a.39.39,0,0,1,.29-.44q7.73-3.08,15.43-6.18a1.62,1.62,0,0,1,1.31,0l24,9.63.73.31Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.69,33.06,44,30.62,60.1,23.14a1,1,0,0,1,.91,0Q71.45,28,81.9,32.8c.16.07.3.16.54.29l-4.69,2.18q-8.23,3.81-16.46,7.63a1.58,1.58,0,0,1-1.45,0q-10.12-4.71-20.26-9.39l-.9-.44Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,8.87l-5,2q-9.85,4-19.72,7.93a1.5,1.5,0,0,1-1.26,0Q10.26,15.7,2.54,12.63a.43.43,0,0,1-.32-.48v-4c0-.26,0-.39.31-.49L21.24.13a1.06,1.06,0,0,1,.87-.06L43.6,8.72Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.61,37.12l-8.43,3.37Q23.6,42.32,19,44.17a1.16,1.16,0,0,1-.93,0Q10.31,41,2.51,37.93c-.26-.1-.31-.24-.31-.5V30.86a.43.43,0,0,1,.33-.48q7.77-3.09,15.54-6.22a1.08,1.08,0,0,1,.88-.05L33.68,30c.08,0,.16.08.32.16l-1.27.6a2.43,2.43,0,0,0,0,4.54c1.26.55,2.49,1.15,3.87,1.79Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.07,100.43H21.26c-.2,0-.62.19-.58-.21s-.44-1,.35-1.34q11.56-4.6,23.12-9.27l5.48-2.2a1.16,1.16,0,0,1,.93,0L79.1,98.87c.17.07.46.07.48.28a5.83,5.83,0,0,1,0,1.18c0,.11-.15.1-.24.1H50.07Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.39,46.85l-12.22,4.9c-4.18,1.68-8.35,3.34-12.52,5a1.41,1.41,0,0,1-1.14,0L25.22,47l-.48-.21,2.43-1q7.34-2.94,14.67-5.89a1,1,0,0,1,.92,0c5.52,2.57,11,5.11,16.56,7.69a2.71,2.71,0,0,0,2.52,0c2.29-1.11,4.6-2.15,6.9-3.22a.74.74,0,0,1,.65-.07c1.93.79,3.87,1.56,5.8,2.34a.91.91,0,0,1,.19.16Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.38,25.67c1.39-.56,2.65-1.06,3.9-1.58a1,1,0,0,1,.82.08l15,6c.87.35.87.35.87,1.37,0,1.85,0,3.7,0,5.55,0,.5-.09.74-.57.93q-7.68,3-15.33,6.13a1.12,1.12,0,0,1-.93,0c-2-.8-3.9-1.57-5.86-2.35l-.45-.21,3.82-1.78,9.76-4.52A2.31,2.31,0,0,0,90,33,2.38,2.38,0,0,0,88.4,30.8c-3.42-1.56-6.83-3.15-10.24-4.73l-.78-.39Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.81,72.08l9.74-3.92c.33-.13.43-.07.42.33,0,2.42,0,4.84,0,7.26,0,.33,0,.46-.38.32L88,72.22a2.54,2.54,0,0,1-.21-.15Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.46,21.51,8.82,23c-2,.82-4.08,1.63-6.12,2.47-.36.15-.5.14-.49-.35,0-2.37,0-4.75,0-7.12,0-.33,0-.58.42-.4,3.22,1.31,6.44,2.59,9.82,3.94Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.37,72.15,8.48,73.71c-1.92.77-3.84,1.53-5.75,2.32-.38.15-.52.15-.52-.37,0-2.36,0-4.71,0-7.07,0-.29-.07-.63.4-.43L12.23,72s0,0,.13.12Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.35,46.86l-9.7,3.9c-.33.13-.44.06-.43-.34V43.17c0-.31,0-.47.38-.33l9.6,3.87s.06,0,.15.14Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.73,46.82l5-2c1.56-.63,3.12-1.24,4.67-1.88.38-.16.57-.21.56.38,0,2.35,0,4.71,0,7.06,0,.33,0,.59-.43.41Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.82,100.31,92,98.24c1.83-.73,3.66-1.45,5.47-2.21.45-.19.55-.08.53.43,0,1.18,0,2.35,0,3.53,0,.3,0,.45-.38.45H86.82a.62.62,0,0,0,0-.13Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.47,100.43H2.64c-.33,0-.42-.13-.42-.47,0-1.22,0-2.44,0-3.66,0-.32,0-.47.38-.33l10.69,4.31s.06,0,.17.15Z",
    style: {
      fill: "#E66C00"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteAdhesiveSpeciallyForLightBaseTile);
export default __webpack_public_path__ + "static/media/white-adhesive-specially-for-light-base-tile.d3d22c195526e71fe0da6919e4dab4c5.svg";
export { ForwardRef as ReactComponent };